import { ComponentCreator, Cursor, DataSource, Label, Panel, Textbox } from "@mcleod/components";
import { Alignment } from "@mcleod/core";

export class DistanceAlertUtil {
    panel: Panel;
    public unclearedDistanceAlertsExist(sourceDistanceAlert: DataSource): boolean {
        let unclearedAlertsExists = false;
        for (const row of sourceDistanceAlert.data) {
            if ("N" === row?.get("is_cleared")) {
                unclearedAlertsExists = true;
                break;
            }
        }
        return unclearedAlertsExists;
    }

    checkForDistanceAlertsTextbox(sourceDistanceAlert: DataSource, textbox: Textbox) {
        const alerts = sourceDistanceAlert.activeRow;

        /** Display a warning if there is a Distance Alert associated with an uncleared Order */
        if (alerts != null ) {
            // Get the last row which is the most recent alert
            const row = sourceDistanceAlert.data[sourceDistanceAlert.data.length-1];
            if ("N" === row?.get("is_cleared")) {
                textbox.color = "warning";
                textbox.borderColor = "warning";
                textbox.borderWidth = 1;
                this.createTextboxHoverToDiscover(textbox, row);
                textbox.allowTooltip = true;
            } else {
                textbox.allowTooltip = false;
            }
        } else {
            textbox.allowTooltip = false;
        }
    }

    private createTextboxHoverToDiscover(textbox: Textbox, row: any) {
        textbox.tooltipPosition = Alignment.RIGHT;
        this.panel = new Panel({ id: "panelHoverToDisplay", maxWidth: 400, cursor: Cursor.DEFAULT }) as Panel;
        const labelOne = new Label({ id: "hoverIdOne", fontBold: true, fontSize: "xlarge", text: `Distance lookup warning`, rowBreak: false });
        const labelTwo = new Label({ id: "hoverIdTwo", text: "" + row?.get("comments"), rowBreak: true });
        this.panel.add(labelOne);
        this.panel.add(labelTwo);

        textbox.tooltipDynamicContent = this.panel;
    }
}
